import ScrollBooster from "scrollbooster";
import PerfectScrollbar from "perfect-scrollbar";
import DeviceChecker from "./device-checker";

document.addEventListener("DOMContentLoaded", function () {
  const viewport = document.querySelector(".js-sb-scroll-compare");
  const content = document.querySelector(".js-ps-scroll-compare");
  if (DeviceChecker.isIE() && viewport) {
    viewport.querySelector(".p-presses-show-compare__list").setAttribute("style", "overflow-x:auto");
  } else {
    if (content) {
      new PerfectScrollbar(content, { suppressScrollY: true });
    }
    if (viewport) {
      new ScrollBooster({
        viewport: viewport,
        scrollMode: "native",
        direction: "horizontal",
        bounce: false,
      });
      if (navigator.platform.indexOf("Mac") !== -1) {
        viewport.setAttribute("style", "overflow-x:auto");
      }
    }
  }
});
